export const isRecommendationTag = (tags?: string | string[] | null): boolean => {
  if (!tags) {
    return false;
  }
  return tags === 'RECOMMENDED_FOR_YOU' || tags.includes('RECOMMENDED_FOR_YOU');
};

export const checkEmailRegex =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
